import { render, staticRenderFns } from "./DeliveryForm.vue?vue&type=template&id=5be91cba"
import script from "./DeliveryForm.vue?vue&type=script&lang=js"
export * from "./DeliveryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports